import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function ProductSummarySkuSelector(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductSummarySkuSelector',
		componentId: uuidv4(),
		props: _.merge(
			{
				showVariationsLabels: 'none',
				showValueForVariation: 'none',
				variationsSpacing: 5,
				imageHeight: 40,
				imageWidth: 40,
			},
			props,
		),
		childrenComponents,
	};
}
